import { render, staticRenderFns } from "./CreateBenchmarkButton.vue?vue&type=template&id=2bb651b4&scoped=true&"
import script from "./CreateBenchmarkButton.vue?vue&type=script&lang=js&"
export * from "./CreateBenchmarkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb651b4",
  null
  
)

export default component.exports